export default __webpack_public_path__ + "static/media/greenProfile.02d4a2ae.svg";